<template>
  <div class="sms-shot-configuration">
    <sms-configuration
      v-model="textValue"
      class="pl-6 pr-4"
      :is-maria-campaign-activated="isMariaCampaignActivated"
      :is-maria-campaign-finished="isMariaCampaignFinished"
      :disabled="disabled"
      :offer-type="offerType"
      :error="getSafe(() => validations.campaign.shotConfiguration.sms.text.$error)"
    />
    <clients-range-slider channel="sms" :segments="campaign.segments" :version="campaign.version" />
    <credit-entry
      title="Quantidade de disparos SMS disponíveis"
      :credits.sync="creditsValue"
      :disabled="disabled"
      :is-maria-campaign-activated="isMariaCampaignActivated"
      :is-maria-campaign-finished="isMariaCampaignFinished"
      channel-type="sms"
      :validations="
        getSafe(() => validations.campaign.shotConfiguration.sms.credits.$error) ? 'Defina a quantidade de créditos disponíveis nesta campanha.' : ''
      "
    />
  </div>
</template>

<script>
import ClientsRangeSlider from '@/modules/maria/campanha-da-maria/views/components/ClientsRangeSlider.vue'
import CreditEntry from '@/modules/maria/campanha-da-maria/views/components/CreditEntry.vue'
import SmsConfiguration from '@/modules/campanhas/campanhas-sms/views/components/SmsConfiguration.vue'

export default {
  name: 'SmsChannel',
  components: {
    SmsConfiguration,
    ClientsRangeSlider,
    CreditEntry,
  },
  props: {
    text: {
      type: String,
      default: () => '',
    },
    credits: {
      type: String,
      default: () => '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    validations: {
      type: Object,
      required: true,
    },
    campaign: {
      type: Object,
      required: true,
    },
    isMariaCampaignActivated: {
      type: Boolean,
      default: false,
    },
    isMariaCampaignFinished: {
      type: Boolean,
      default: false,
    },
    offerType: {
      type: String,
      default: 'general',
    },
  },
  data: () => ({
    errorData: false,
  }),
  computed: {
    campaignVersion() {
      return this.campaign.version === 2 || !this.campaign._id ? 'V2' : 'V1'
    },
    textValue: {
      get() {
        return this.text
      },
      set(value) {
        this.$emit('update:text', value)
      },
    },
    creditsValue: {
      get() {
        return this.credits
      },
      set(value) {
        this.$emit('update:credits', value)
      },
    },
  },
}
</script>

<style lang="scss" scoped>
.sms-shot-configuration {
  > .v-card {
    box-shadow: none;
  }
}
</style>
